import React, { useState } from "react";
import Image from "components/Elements/Image/Image.tsx";
import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import config from "config";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./brandingModal.scss";

const BrandingModal = () => {
  const { getTextByKey, getPath } = useContent();
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    const res = await apiRequest(
      "Users",
      "UpdateUserCoverOnHomePage",
      {
        homePageCover: true,
      },
      "PUT"
    );
    if (res) {
      window.location.href = `${
        config.baseurl
      }${getPath()}user/branding/cover-logo`;
    }
  };

  return (
    <div className="branding-modal-content">
      <Image name="edit-background" />
      <div className="branding-modal-title">
        {getTextByKey("update-default-cover-title")}
      </div>
      <div className="branding-modal-text">
        {getTextByKey("home-branding-description")}
      </div>
      <Button onClick={handleClick}>
        {" "}
        {loading ? (
          <Image name="preloader" ext="gif" />
        ) : (
          getTextByKey("add-image")
        )}
      </Button>
    </div>
  );
};

export default BrandingModal;
